import React from 'react';
import {useMenu} from '../../../hooks/useMenu';
import ProgressBarView from '../../views/progressbarView';
import ZeroVerFinished from './zero-ver-finished';
import {useTranslation, withTranslation, Trans} from 'react-i18next';

function VerificationPB() {
  const {onComponent} = useMenu();
  const {t, i18n} = useTranslation();
  const changeLanguage = lng => {
    i18n.changeLanguage(lng);
  };
  return (
    <ProgressBarView
      title={t('zeroVerif.title')}
      content={t('zeroVerif.a8')}
      onExit={() => onComponent(<ZeroVerFinished />)}
    />
  );
}

export default VerificationPB;
